import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./AdminFunctions.css";

const AdminFunctions = ({ functions = [] }) => {
  const navigate = useNavigate();
  const [counts, setCounts] = useState([]);

  useEffect(() => {
    const controller = new AbortController();

    const parseCount = async (res) => {
      // Try JSON first
      try {
        const data = await res.clone().json();
        if (typeof data === "number") return data;
        if (data && typeof data === "object") {
          if ("count" in data) return Number(data.count);
          if ("total" in data) return Number(data.total);
          // fallback: first numeric value in object
          const firstNum = Object.values(data).find((v) => !isNaN(Number(v)));
          if (!isNaN(Number(firstNum))) return Number(firstNum);
        }
      } catch (_) {
        /* fall through to text */
      }

      // Fallback to plain text/number
      const text = await res.text();
      const n = parseInt(text, 10);
      return isNaN(n) ? null : n;
    };

    const fetchCounts = async () => {
      const results = await Promise.allSettled(
        functions.map(async (f) => {
          if (!f?.countApi) return null;
          const res = await fetch(f.countApi, { signal: controller.signal });
          if (!res.ok) throw new Error("Bad response");
          return await parseCount(res);
        })
      );
      setCounts(
        results.map((r) => (r.status === "fulfilled" ? r.value : null))
      );
    };

    fetchCounts().catch(() => {});
    return () => controller.abort();
  }, [functions]);

  const formatCount = (n) => (n > 999 ? "999+" : n);

  return (
    <div className="admin-functions-container">
      {functions.map((func, index) => (
        <div
          key={index}
          className="admin-function-box"
          role="button"
          tabIndex={0}
          onClick={() => navigate(func.link)}
          onKeyDown={(e) =>
            (e.key === "Enter" || e.key === " ") && navigate(func.link)
          }
        >
          {/* Count bubble */}
          {counts[index] != null && (
            <span className="admin-function-badge">
              {formatCount(counts[index])}
            </span>
          )}

          <div className="admin-function-iconCircle">
            {func.icon?.startsWith("fa-") ? (
              <i className={`fas ${func.icon} admin-function-icon`} />
            ) : (
              <img
                src={func.icon}
                alt={func.name}
                className="admin-function-icon"
              />
            )}
          </div>

          <span className="admin-function-text">{func.name}</span>
        </div>
      ))}
    </div>
  );
};

export default AdminFunctions;
